const breadcrumbModule = {
    namespaced: true,
    state: {
      route: [],
    },
    getters: {
      getRoute(state) {
        return state.route;
      },
    },
    actions: {
      setRoute({commit}, route) {
        commit('setRoute', route);
      },
    },
    mutations: {
      setRoute(state, route) {
        state.route = route;
      },
    }
  }

  export default breadcrumbModule;